import useIsMobile from '@/features/shared/Hooks/useIsMobile';
import clsx from 'clsx';
import React from 'react';
import { PortalNavigationVariants } from './PortalNavigation.constants';
import { PortalNavigationProps } from './PortalNavigation.interfaces';
import usePortalNavigationStyles from './PortalNavigation.styles';
import { DropdownNavigation } from './variants/dropdown/DropdownNavigation/DropdownNavigation';
import { InlineNavigation } from './variants/inline/InlineNavigation';
import { MobilePortalNavigation } from './variants/mobile/MobilePortalNavigation/MobilePortalNavigation';

const VariantsMap = {
  [PortalNavigationVariants.DROPDOWN]: DropdownNavigation,
  [PortalNavigationVariants.INLINE]: InlineNavigation,
};

const PortalNavigation = (props: Br.PropsWithContentButtons<PortalNavigationProps>) => {
  const { contentButtons, variant = PortalNavigationVariants.INLINE } = props;

  const classes = usePortalNavigationStyles({
    isSticky: variant === PortalNavigationVariants.INLINE,
  });
  const isMobile = useIsMobile();

  const DesktopVariant = VariantsMap[variant];

  return (
    <div id="portal-navigation" className={clsx(classes.root, 'portal-navigation')}>
      <>{contentButtons?.content}</>
      {isMobile ? <MobilePortalNavigation {...props} /> : <DesktopVariant {...props} />}
    </div>
  );
};

export default PortalNavigation;
